import {
    Badge,
    Box,
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text, useColorModeValue,
} from "@chakra-ui/react";
import React from "react";

function UserDetailModal({isOpen, onClose, userDetails}) {

    const colorStatus = useColorModeValue("white", "gray.400");

    return (
        <Modal isOpen={isOpen} onClose={() => onClose(null, false)} size="md">
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>User Details</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Stack spacing={3}>
                        <Text><strong>Full Name:</strong> {userDetails.fullName}</Text>
                        <Text><strong>Address:</strong> {userDetails.address}</Text>
                        <Text><strong>School Name:</strong> {userDetails.schoolName}</Text>
                        <Text><strong>Mobile Number:</strong> {userDetails.mobileNumber}</Text>
                        <Text><strong>Email Address:</strong> {userDetails.email}</Text>
                        <Text><strong>Is OTP Verified:</strong> {userDetails?.isOtpVerified ? "Yes" : "No"}</Text>
                        <Text><strong>Status:</strong> <Badge
                            bg={userDetails?.status === "Y" ? "green.400" : userDetails?.status === "P" ? "yellow.400" : bgStatus}
                            color={userDetails?.status === "N" ? "white" : colorStatus}
                            fontSize="16px"
                            p="3px 10px"
                            borderRadius="8px"
                        >
                            {
                                userDetails?.status === 'Y' ? "Active" : userDetails?.status === "P" ? "Pending" : "Inactive"
                            }
                        </Badge>
                        </Text>
                        <Text><strong>Wrong Password Attempt:</strong> {userDetails?.wrongPasswordAttempt}</Text>
                        <Text><strong>Designation:</strong> {userDetails.designation}</Text>
                        <Text><strong>Role:</strong> {userDetails.roleCode}</Text>
                        <Text><strong>Role:</strong> {userDetails.roleName}</Text>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={() => onClose(null, false)}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default UserDetailModal;